import { render, staticRenderFns } from "./FormBan.vue?vue&type=template&id=55728111&"
import script from "./FormBan.vue?vue&type=script&lang=js&"
export * from "./FormBan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports